export class AppSettings {
  static readonly DATASET = 1;

  static readonly NODE_COLOUR = '#ffffff';
  static readonly NODE_SUBNETWORK_COLOUR = '#999999';
  static readonly NODE_SIZE = 2;
  static readonly NODE_SELECTED_COLOUR = '#ff0000';
  static readonly NODE_SELECTED_SIZE = 5;
  static readonly EDGE_COLOUR = '#696969';
  static readonly BACKGROUND_COLOUR = '#000000';
  static readonly TEXT_COLOUR = '#FFFFFF';
  static readonly TEXT_BACKGROUND_COLOUR = "#000000";
  static readonly TEXT_BORDER_COLOUR = "#ffffff";

  static readonly NODE_SUBNETWORK_SIZE = 10;
  static readonly NODE_SUBNETWORK_SELECTED_SIZE = 15;

  static readonly MIN_SEARCH_LEN = 3;

  static readonly BASE_PAGE_TITLE = "Human Cell Map";
  static readonly LOCAL_URL_PREFIX = "/human";

  static readonly SCORES_SERVER = "https://thecellmap.org/human/api";
  static readonly STATIC_SERVER = "https://thecellmap.org/human/public";

  static readonly CONTACT_LIST = [
    {"name": "Michael Costanzo", "email": "michael.costanzo@utoronto.ca"},
    {"name": "Myra Paz Masinas", "email": "myra.masinas@utoronto.ca"},
    {"name": "Ira Horecka", "email": "ira.horecka@mail.utoronto.ca"},
    {"name": "Matej Ušaj", "email": "m.usaj@utoronto.ca"}
  ];
}
